var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgShevronRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.323 17.417a.918.918 0 00.715-.34l4.427-5.5a.917.917 0 000-1.164l-4.583-5.5A.918.918 0 108.47 6.087L12.568 11l-3.96 4.913a.917.917 0 00.715 1.504z",
    fill: "#fff"
  })));
}

export default SvgShevronRight;